(function () {
  'use strict';
  var root = document.querySelector('main.ptlp');
  if (!root) return;
  var quick = root.querySelector('#pt-quick-b2c');
  var section = root.querySelector('#ptlp-personalizer');
  var observedEntry = null;
  var visibility = new Map();
  var observer = window.IntersectionObserver && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      visibility.set(entry.target, entry.isIntersecting && entry.intersectionRect.height > 0);
    });
    root.dataset.ptlpPersonalizerVisible = Array.from(visibility.values()).some(Boolean) ? '1' : '0';
  }, {rootMargin: '0px 0px -24px 0px', threshold: 0});
  if (section && observer) observer.observe(section);
  function syncEntry() {
    var entry = root.querySelector('#pt-unified-entry');
    if (!quick || !entry || quick.dataset.ptUnifiedEntry !== '1') return;
    root.dataset.ptlpEntryReady = '1';
    root.dataset.ptlpEntryExternal = quick.dataset.ptEntryExternal || '0';
    if (entry !== observedEntry && observer) {
      if (observedEntry) {observer.unobserve(observedEntry);visibility.delete(observedEntry);}
      observer.observe(entry);observedEntry = entry;
    }
  }
  syncEntry();
  if (quick) new MutationObserver(syncEntry).observe(quick, {
    attributes: true, attributeFilter: ['data-pt-unified-entry', 'data-pt-entry-external']
  });
  root.querySelectorAll('.ptlp-gallery').forEach(function (gallery) {
    var track = gallery.querySelector('.ptlp-product-gallery');
    var slides = Array.from(track.querySelectorAll('a'));
    var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-index]'));
    if (slides.length < 2) return;
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var counter = gallery.querySelector('[data-gallery-counter]');
    var index = 0, frame = 0;
    function leftOf(slide) {return slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;}
    function sync() {
      frame = 0;
      var left = track.getBoundingClientRect().left;
      index = slides.reduce(function (best, slide, i) {
        return Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best;
      }, 0);
      prev.disabled = index === 0;next.disabled = index === slides.length - 1;
      counter.textContent = (index + 1) + ' / ' + slides.length;
      thumbs.forEach(function (button, i) {
        if (i === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
        slides[i].tabIndex = i === index ? 0 : -1;
      });
      // Scroll only the thumbnail strip; never move the page during a swipe.
      var active = thumbs[index], strip = active.parentElement;
      var activeBox = active.getBoundingClientRect(), stripBox = strip.getBoundingClientRect();
      if (activeBox.left < stripBox.left || activeBox.right > stripBox.right) {
        strip.scrollTo({left: strip.scrollLeft + activeBox.left - stripBox.left - (strip.clientWidth - activeBox.width) / 2, behavior: 'instant'});
      }
    }
    function go(n) {
      n = Math.max(0, Math.min(slides.length - 1, n));
      track.scrollTo({left: leftOf(slides[n]), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    prev.addEventListener('click', function () {go(index - 1);});
    next.addEventListener('click', function () {go(index + 1);});
    thumbs.forEach(function (button, i) {button.addEventListener('click', function () {go(i);});});
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();go(index + (event.key === 'ArrowRight' ? 1 : -1));}
    });
    track.addEventListener('scroll', function () {if (!frame) frame = requestAnimationFrame(sync);}, {passive: true});
    if (window.ResizeObserver) new ResizeObserver(function () {track.scrollTo({left: leftOf(slides[index]), behavior: 'instant'});sync();}).observe(track);
    gallery.querySelector('.ptlp-gallery-controls').hidden = false;
    gallery.querySelector('.ptlp-gallery-thumbs').hidden = false;
    sync();
  });
})();
